// extracted by mini-css-extract-plugin
module.exports = {"date":"_3r4bq","eventList":"_3aZOC","dateText":"_2Air_","eventDetails":"_27Ixw","dateWithChevron":"_37omk","dateChevron":"_3uAXo","clickable":"_10Orq","close":"_2bWVz"};